import { ComponentElement } from './stores/componentManager';

import Accordion from './webcomponents/accordion';
import Calendar from './webcomponents/calendar';
import Carousel from './webcomponents/carousel';
import Heading from './webcomponents/heading';
import MediasSlider from './webcomponents/mediasSlider';
import ParallaxImage from './webcomponents/parallaxImage';
import TagsListing from './webcomponents/tagsListing';
import VideoInline from './webcomponents/videoInline';
import InputQuantity from './webcomponents/inputQuantity';
import ListingAnchors from './webcomponents/listingAnchors';
import Modal from './webcomponents/modal';
import Dropdown from './webcomponents/dropdown';
import Tabs from './webcomponents/tabs';
import FormHotel from './webcomponents/formHotel';
import FormRestaurant from './webcomponents/formRestaurant';
import FormEvent from './webcomponents/formEvent';
import BookingWidget from './webcomponents/bookingWidget';
import Wysiwyg from './webcomponents/wysiwyg';
import BookingCombobox from './webcomponents/bookingCombobox';
import Filters from './webcomponents/filters';
import BookingCta from './webcomponents/booking-cta';
import Newspaper from './webcomponents/newspaper';
import FormNewsletter from './webcomponents/formNewsletter';
import 'cally';

export default async function () {
    customElements.define('c-calendar', ComponentElement(Calendar, 'Calendar'));
    customElements.define('c-accordion', ComponentElement(Accordion, 'Accordion'));
    customElements.define('c-heading', ComponentElement(Heading, 'Heading'));
    customElements.define('c-medias-slider', ComponentElement(MediasSlider, 'MediasSlider'));
    customElements.define('c-tags-listing', ComponentElement(TagsListing, 'TagsListing'));
    customElements.define('c-video-inline', ComponentElement(VideoInline, 'VideoInline'));
    customElements.define('c-parallax-image', ComponentElement(ParallaxImage, 'ParallaxImage'));
    customElements.define('c-carousel', ComponentElement(Carousel, 'Carousel'));
    customElements.define('c-listing-anchors', ComponentElement(ListingAnchors, 'ListingAnchors'));
    customElements.define('c-input-quantity', ComponentElement(InputQuantity, 'InputQuantity'));
    customElements.define('c-modal', ComponentElement(Modal, 'Modal'));
    customElements.define('c-dropdown', ComponentElement(Dropdown, 'Dropdown'));
    customElements.define('c-tabs', ComponentElement(Tabs, 'Tabs'));
    customElements.define('c-form-restaurant', ComponentElement(FormRestaurant, 'FormRestaurant'));
    customElements.define('c-form-event', ComponentElement(FormEvent, 'FormEvent'));
    customElements.define('c-form-hotel', ComponentElement(FormHotel, 'FormHotel'));
    customElements.define('c-booking-widget', ComponentElement(BookingWidget, 'BookingWidget'));
    customElements.define(
        'c-booking-combobox',
        ComponentElement(BookingCombobox, 'BookingCombobox')
    );
    customElements.define('c-wysiwyg', ComponentElement(Wysiwyg, 'Wysiwyg'));
    customElements.define('c-filters', ComponentElement(Filters, 'Filters'));
    customElements.define('c-booking-cta', ComponentElement(BookingCta, 'BookingCta'));
    customElements.define('c-ns', ComponentElement(Newspaper, 'Newspaper'));
    customElements.define('c-form-newsletter', ComponentElement(FormNewsletter, 'FormNewsletter'));
}
